// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2nUxd","content":"styles_content__3WSkX","selectAll":"styles_selectAll__2vfeX"};